export const applyHDRMode = async (canvas, ctx, setMessage, language) => {
  // 진행 상황 업데이트
  setMessage(language === 'KR' ? 'HDR 모드 적용 중 (1/3) - 노출 조정...' : 'Applying HDR Mode (1/3) - Adjusting exposure...');
  await new Promise(resolve => setTimeout(resolve, 500));
  
  // HDR 모드 효과 적용
  // 1. 로컬 콘트라스트 향상 및 그림자 영역 밝게
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const data = imageData.data;
  
  // 히스토그램 생성
  const histogram = new Array(256).fill(0);
  for (let i = 0; i < data.length; i += 4) {
    const avg = Math.floor((data[i] + data[i + 1] + data[i + 2]) / 3);
    histogram[avg]++;
  }
  
  // 누적 히스토그램
  const cdf = new Array(256).fill(0);
  cdf[0] = histogram[0];
  for (let i = 1; i < 256; i++) {
    cdf[i] = cdf[i - 1] + histogram[i];
  }
  
  // 히스토그램 균등화 매핑 계산
  const pixelCount = canvas.width * canvas.height;
  const mapping = new Array(256);
  for (let i = 0; i < 256; i++) {
    mapping[i] = Math.round(255 * cdf[i] / pixelCount);
  }
  
  // 히스토그램 균등화 적용 (HDR 효과의 핵심)
  for (let i = 0; i < data.length; i += 4) {
    data[i] = mapping[data[i]];
    data[i + 1] = mapping[data[i + 1]];
    data[i + 2] = mapping[data[i + 2]];
  }
  
  ctx.putImageData(imageData, 0, 0);
  
  // 2. 색상 강화
  setMessage(language === 'KR' ? 'HDR 모드 적용 중 (2/3) - 색상 강화...' : 'Applying HDR Mode (2/3) - Enhancing colors...');
  await new Promise(resolve => setTimeout(resolve, 500));
  
  const colorData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const colorPixels = colorData.data;
  
  // 색상 강화
  for (let i = 0; i < colorPixels.length; i += 4) {
    // 채도 증가
    const avg = (colorPixels[i] + colorPixels[i + 1] + colorPixels[i + 2]) / 3;
    colorPixels[i] = Math.min(255, avg + (colorPixels[i] - avg) * 1.2);
    colorPixels[i + 1] = Math.min(255, avg + (colorPixels[i + 1] - avg) * 1.2);
    colorPixels[i + 2] = Math.min(255, avg + (colorPixels[i + 2] - avg) * 1.2);
  }
  
  ctx.putImageData(colorData, 0, 0);
  
  // 3. 로컬 콘트라스트 향상
  setMessage(language === 'KR' ? 'HDR 모드 적용 중 (3/3) - 디테일 강화...' : 'Applying HDR Mode (3/3) - Enhancing details...');
  await new Promise(resolve => setTimeout(resolve, 500));
  
  const detailData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const detailPixels = detailData.data;
  
  const tempCanvas = document.createElement('canvas');
  tempCanvas.width = canvas.width;
  tempCanvas.height = canvas.height;
  const tempCtx = tempCanvas.getContext('2d');
  tempCtx.drawImage(canvas, 0, 0);
  const tempData = tempCtx.getImageData(0, 0, canvas.width, canvas.height).data;
  
  // 로컬 콘트라스트 향상을 위한 언샵 마스킹
  for (let y = 1; y < canvas.height - 1; y++) {
    for (let x = 1; x < canvas.width - 1; x++) {
      const pos = (y * canvas.width + x) * 4;
      
      for (let c = 0; c < 3; c++) {
        const current = tempData[pos + c];
        const top = tempData[pos - canvas.width * 4 + c];
        const bottom = tempData[pos + canvas.width * 4 + c];
        const left = tempData[pos - 4 + c];
        const right = tempData[pos + 4 + c];
        
        // 디테일 강화
        detailPixels[pos + c] = Math.min(255, Math.max(0, 
          current * 1.7 - (top + bottom + left + right) / 8));
      }
    }
  }
  
  ctx.putImageData(detailData, 0, 0);
  
  // 처리 완료
  setMessage(language === 'KR' ? 'HDR 모드 적용 완료!' : 'HDR Mode applied!');
};